import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";
import type {
    AttachmentOrientation
} from "../../type";

const stylesheet = StyleSheet.create({
    container: {
        flexDirection: "column",
        flexShrink: 1,
        flexGrow: 1,
        minWidth: 0
    }
});

export const useStyles = ({
    orientation,
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
    orientation: AttachmentOrientation;
}) => {
    const styles = {
        container: {
        } as Mutable<ViewStyle>
    };

    if(orientation === "vertical") {
        styles.container.paddingStart = spaces.spacingXxs;
    }

    return styles;
};
export default stylesheet;
